interface HeroSectionProps {
  lang: 'pt' | 'en';
}

const content = {
  pt: {
    line1: 'Mais Clientes. Menos Trabalho.',
    line2: 'Tudo Automático',
    sub: 'Tratamos das respostas, do seguimento e de cada oportunidade para venderes mais, sem perder tempo.',
    cta: 'Ver Como Funciona →',
  },
  en: {
    line1: 'More Customers. Less Work.',
    line2: 'Fully Automated',
    sub: 'We handle replies, follow ups, and every opportunity so you can sell more without wasting time.',
    cta: 'How It Works →',
  },
};

export function HeroSection({ lang }: HeroSectionProps) {
  const t = content[lang];

  const scrollToContact = () => {
    const el = document.getElementById('servicos');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-purple-900/20 to-slate-900" />

      {/* Content */}
      <div className="relative z-10 w-full px-6 text-center flex flex-col items-center">
        {/* Line 1 */}
        <h1 className="text-5xl md:text-7xl font-extralight text-white mb-3 tracking-[0.06em] leading-tight animate-fade-in">
          {t.line1}
        </h1>

        {/* Line 2 — purple-blue gradient, visual companion to H1 not a section heading */}
        <p className="text-5xl md:text-7xl font-extralight mb-8 tracking-[0.06em] leading-tight animate-fade-in bg-gradient-to-r from-blue-400 via-purple-400 to-indigo-400 bg-clip-text text-transparent">
          {t.line2}
        </p>

        {/* Subheadline */}
        <p className="text-lg text-white/60 mb-12 max-w-[560px] mx-auto leading-relaxed font-light">
          {t.sub}
        </p>

        {/* CTA */}
        <a
          href="#servicos"
          onClick={(e) => { e.preventDefault(); scrollToContact(); }}
          className="bg-transparent border border-white/40 text-white px-8 py-4 rounded-xl text-base font-light transition-all duration-300 hover:border-purple-400 hover:bg-purple-500/10 whitespace-nowrap cursor-pointer tracking-wide"
        >
          {t.cta}
        </a>
      </div>
    </section>
  );
}
